import Navbar from "../components/ui/navbar";

const DownloadPage = () => {
  return (
    <>
      <div className="relative w-full py-8 border-b shrink-0">
        <Navbar />
      </div>

      <div className="min-h-screen">
        <div className="pt-8">
          <div className="max-w-5xl mx-auto sm:px-6 lg:px-8">
            <h2 className="mb-2 text-3xl font-bold tracking-tight text-center sm:text-4xl">
              Downloads
            </h2>
          </div>
        </div>

        <div className="max-w-5xl p-4 mx-auto sm:px-6 lg:px-8">
          <div className="mb-8 overflow-hidden bg-white border rounded-lg">
            <div className="p-6">
              <p className="mb-3 font-semibold text-gray-800">
                Welcome to the LNPDB downloads page.
              </p>

              <p className="mb-6 text-sm text-gray-700">
                Here you can download the database and corresponding CHARMM
                topology (RTF) and parameter (PRM) files for the individual
                lipid components in LNP formulations.
              </p>

              <div className="mb-12">
                <h3 className="pb-2 mb-4 text-xl font-semibold text-gray-900 border-b">
                  LNPDB Spreadsheet File
                </h3>
                <div className="flex flex-col p-4 mt-4 transition-all border rounded-lg hover:shadow-md">
                  <div className="flex items-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-3 text-blue-600 size-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 10h16M4 14h16M4 18h16"
                      />
                    </svg>
                    <h3 className="text-lg font-medium">LNPDB Dataset</h3>
                  </div>
                  <p className="mb-4 text-sm text-gray-600">
                    Download the complete LNPDB dataset in CSV format.
                  </p>
                  <a
                    href="/LNPDB.csv"
                    download
                    className="flex items-center justify-center px-4 py-2 mt-auto text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 size-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download LNPDB.csv
                  </a>
                </div>
              </div>

              <div className="p-4 mt-8 mb-6 text-left border-l-4 border-blue-500 rounded-md bg-blue-50">
                <div className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-3 text-blue-600 size-6 shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <p className="font-semibold text-blue-800">Please note:</p>
                    <div className="mt-1 text-sm text-gray-700 text-balance">
                      <p className="mt-1">
                        - These downloads include only the CHARMM RTF/PRM
                        definitions specific to the lipids in LNPDB
                        formulations.
                      </p>
                      <p className="mt-1">
                        - They do not contain the general CGenFF topology or
                        parameter files.
                      </p>
                      <p className="mt-1">
                        - For the standard CHARMM-GUI Topology & Parameters
                        (CGenFF) resources:{" "}
                        <a
                          href="https://www.charmm-gui.org/?doc=toppar"
                          className="font-medium text-blue-600 underline hover:text-blue-700"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          charmm-gui.org
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="pb-2 mb-4 text-xl font-semibold text-gray-900 border-b">
                Downloads
              </h3>
              <div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2">
                <div className="flex flex-col p-4 transition-all border rounded-lg hover:shadow-md">
                  <div className="flex items-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-3 text-blue-600 size-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                      />
                    </svg>
                    <h3 className="text-lg font-medium">Parameter Files</h3>
                  </div>
                  <p className="mb-4 text-sm text-gray-600">
                    Download CHARMM parameter files (PRM) for force field
                    calculations.
                  </p>
                  <a
                    href="/prm_files.zip"
                    download
                    className="flex items-center justify-center px-4 py-2 mt-auto text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 size-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download PRM Files
                  </a>
                </div>
                <div className="flex flex-col p-4 transition-all border rounded-lg hover:shadow-md">
                  <div className="flex items-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-3 text-blue-600 size-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                      />
                    </svg>
                    <h3 className="text-lg font-medium">Topology Files</h3>
                  </div>
                  <p className="mb-4 text-sm text-gray-600">
                    Download CHARMM topology files (RTF) for molecular structure
                    definitions.
                  </p>
                  <a
                    href="/rtf_files.zip"
                    download
                    className="flex items-center justify-center px-4 py-2 mt-auto text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 size-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download RTF Files
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadPage;
